import forgotPasswordTypes from './forgotPasswordTypes'

export default {
  sendForgotPasswordEmail: payload => {
    return {
      type: forgotPasswordTypes.SEND_FORGOT_PASSWORD_EMAIL,
      payload
    }
  },
  sendForgotPasswordEmailResponse: () => {
    return {
      type: forgotPasswordTypes.SEND_FORGOT_PASSWORD_EMAIL_RESPONSE
    }
  }
}
